import React from 'react';
import Icon from 'components/AppIcon';

export default function IndividualRejectModal({ open, onClose, onSubmit, worker, rejectionReasons = [], form, onFormChange, processing }) {
  if (!open || !worker) return null;

  const workerName = worker?.biodata?.full_name || worker?.biodata?.fullName || 'N/A';
  const passportNo = worker?.biodata?.passport_no || worker?.biodata?.passportNo || 'N/A';

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <h3 className="text-lg font-semibold text-gray-900">Reject Worker</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition">
            <Icon name="X" size={18} />
          </button>
        </div>

        <div className="px-6 py-5 space-y-5">
          <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
            <div className="flex items-center space-x-3">
              <Icon name="User" size={20} className="text-gray-400" />
              <div>
                <p className="text-sm font-semibold text-gray-900">{workerName}</p>
                <p className="text-xs text-gray-500">Passport: {passportNo}</p>
              </div>
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700">Rejection Reason *</label>
            <select
              value={form.reason_id}
              onChange={e => onFormChange({ ...form, reason_id: e.target.value })}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200"
              required
            >
              <option value="">Select a reason</option>
              {rejectionReasons.map(reason => (
                <option key={reason.id} value={reason.id}>
                  {reason.name || reason.reason}
                </option>
              ))}
            </select>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700">Additional Remarks</label>
            <textarea
              value={form.remarks}
              onChange={e => onFormChange({ ...form, remarks: e.target.value })}
              rows={3}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200"
              placeholder="Optional additional comments..."
            />
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 border-t border-gray-100 px-6 py-4">
          <button
            onClick={onClose}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            disabled={processing || !form.reason_id}
            className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {processing ? 'Processing…' : 'Reject Worker'}
          </button>
        </div>
      </div>
    </div>
  );
}
